import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 19V8q0-.824.588-1.412A1.93 1.93 0 0 1 7 6h2V3a.97.97 0 0 1 .287-.712A.97.97 0 0 1 10 2h4a.97.97 0 0 1 .713.288A.97.97 0 0 1 15 3v3h2q.824 0 1.413.588Q19 7.175 19 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21q0 .424-.288.712A.97.97 0 0 1 16 22a.57.57 0 0 1-.563-.363A2.1 2.1 0 0 0 15 21H9a.97.97 0 0 1-.287.712A.97.97 0 0 1 8 22a.57.57 0 0 1-.563-.363A2.1 2.1 0 0 0 7 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19m6-13h2V4h-2zm1 6q1.325 0 2.588-.338A9.7 9.7 0 0 0 17 10.65V8H7v2.65q1.15.675 2.412 1.012A10 10 0 0 0 12 12m-1 2v-.05a16.5 16.5 0 0 1-2.05-.375A12 12 0 0 1 7 12.9V19h10v-6.1q-.95.425-1.95.675T13 13.95V14q0 .424-.287.713A.97.97 0 0 1 12 15a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 14" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }